export const apiCreate = (): string => '/partnerships/routes/'
export const apiList = (id?: string): string =>
  !id ? '/partnerships/routes/' : `/partnerships/routes/view/${id}`
export const apiListOptionsByPromoter = (promoter_id: string): string =>
  `/partnerships/routes/listOptionsByPromoter/?promoter_id=${promoter_id}`
export const apiGetByIdUpdatePage = (id: string): string =>
  `/partnerships/routes/getByIdUpdatePage/${id}`
export const apiUpdate = (id: string): string =>
  `/partnerships/routes/update/${id}`
export const apiDelete = (id: string): string => `/partnerships/routes/${id}`
